import React from 'react';
import { Route } from 'react-router-dom';
import Home from '../Home';
import ErrorBoundary from './ErrorBoundary';


export default [
    <Route exact path="/actions" render={(props) => <Home {...props} /> }  />,
];